import { render, staticRenderFns } from "./CustomerStatementsView.vue?vue&type=template&id=efde733e&scoped=true"
import script from "./CustomerStatementsView.vue?vue&type=script&lang=js"
export * from "./CustomerStatementsView.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatementsView.vue?vue&type=style&index=0&id=efde733e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efde733e",
  null
  
)

export default component.exports